var exports = {
  "m1": "stackBadge__CXihl8",
  "oK": "overlayHeader__AAiwOD",
  "nU": "overlayHeaderContent__NAYprx",
  "GI": "overlayHeaderTitle__yumH64",
  "nf": "overlayHeaderActions__3xkrQB",
  "Yz": "stackNavList__tnBSrW",
  "ie": "addToStackItem__r0KQT5",
  "AC": "branchItem__nF5t8T",
  "ZJ": "branchItemContent___lGbWK",
  "q6": "previewFooter__AreixO",
  "ly": "shortcutGuidance__1dwGa7",
};

module.exports = exports;
